import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  base: '/csci262/spring2020/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/schedule',
      name: 'schedule',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "schedule" */ './views/Schedule.vue')
    },
    {
      path: '/policies',
      name: 'policies',
      component: () => import(/* webpackChunkName: "policies" */ './views/Policies.vue')
    },
    {
      path: '/assignments',
      name: 'assignments',
      component: () => import(/* webpackChunkName: "assignments" */ './views/Assignments.vue')
    },
    {
      path: '/labs',
      name: 'labs',
      component: () => import(/* webpackChunkName: "labs" */ './views/Labs.vue')
    },
    {
      path: '/help',
      name: 'help',
      component: () => import(/* webpackChunkName: "help" */ './views/Help.vue')
    },
    {
      path: '/writeup/:folder/:name',
      component: () => import(/* webpackChunkName: "markdown" */ './views/Markdown.vue')
    }    
  ]
})
